import { CommanSubscribeService } from "./core/services/comman-subscribe.service";
import {
  Router,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { Component } from "@angular/core";
import { StorageService } from "./core/services/storage.service";
import { LandingPageService } from "./core/services/landing-page.service";
import { environment } from "src/environments/environment";
import { FullStory, init } from "@fullstory/browser";
import { Subscription } from "rxjs";
import { MetamaskService } from "./core/services/wallet-connect.service";
import { GlobalPubnubService } from "./core/services/global-pubnub.service";
import { UserActivityService } from "./core/services/user-activity.service";
declare let window: any;
declare let device: any;
const DEFAULT_LOADER_OVERLAY_COLOR = "rgba(66,64,64,0.8)";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "bigbeeai";

  signedIn: boolean;
  user: any;
  userInfo: any = {};
  otherDevice: boolean = true;
  userInfoSubscription: Subscription;
  iphone: boolean = false;
  deviceInfoSubscription: Subscription;
  deviceInfo: string = "web";
  hideContent: boolean = false;
  content: string = "live";
  assets_url = environment.assets_url;
  enable_aichatbot = environment.enable_aichatbot;
  newAgentHome = (environment as any).enableNewAgentHome === true;
  currentLocation: any;
  clientDetails: any;
  hideAIChatbot: boolean;
  startTime: number = 0;
  triggeredInfoSubscription: Subscription;
  enterTime = Date.now();
  pageDuration: number = 0;
  settingsDataSubscription: Subscription;
  loaderTextColor: string = environment.themeColors["secondaryFontColor"];
  loaderOverlayColor: string = DEFAULT_LOADER_OVERLAY_COLOR;
  private pendingPageView: {
    triggeredInfo: any;
    duration: number;
    timer: any;
  } | null = null;

  startTracking() {
    this.startTime = Date.now();
  }

  stopTracking(pageUrl: string, userId?: string) {
    const endTime = Date.now();
    const duration = Math.floor((endTime - this.startTime) / 1000);
    (window as any).umami?.track(`${pageUrl} - ${userId} - ${duration}`);
  }
  private hexToRgb(color: string): { r: number; g: number; b: number } | null {
    const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color || "");
    if (!match) return null;
    return {
      r: parseInt(match[1], 16),
      g: parseInt(match[2], 16),
      b: parseInt(match[3], 16),
    };
  }

  // Converts a settingsData hex color into an rgba() string with the given opacity,
  // falling back to the app's default accent when the color is missing/unparsable.
  getFadedColor(color: string, opacity: number): string {
    const rgb = this.hexToRgb(color);
    if (!rgb) {
      return `rgba(235, 169, 33, ${opacity})`;
    }
    const { r, g, b } = rgb;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  applyLoaderTheme(theme: any): void {
    if (theme?.toastr_bg_color) {
      document.documentElement.style.setProperty("--loader-color", theme.toastr_bg_color);
    } else {
      document.documentElement.style.removeProperty("--loader-color");
    }
    this.loaderTextColor = theme?.font_primary_color || environment.themeColors["secondaryFontColor"];
    this.loaderOverlayColor = this.hexToRgb(theme?.main_bg_color) ? this.getFadedColor(theme.main_bg_color, 0.8) : DEFAULT_LOADER_OVERLAY_COLOR;
  }

  constructor(
    public router: Router,
    private commanSubscribeService: CommanSubscribeService,
    private landingPageService: LandingPageService,
    private globalPubnubService: GlobalPubnubService,
    private metamaskService: MetamaskService,
    private storageService: StorageService,
    private userActivityService: UserActivityService,
  ) {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        const duration = Number(
          ((Date.now() - this.enterTime) / 1000).toFixed(0),
        );
        this.enterTime = Date.now();
        this.schedulePendingPageView(evt.urlAfterRedirects, duration);
      }
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (evt instanceof NavigationCancel || evt instanceof NavigationError) {
        this.enterTime = Date.now();
      }
      window.scrollTo(0, 0);
    });

    // this.amplifyService.authStateChange$
    //   .subscribe(authState => {
    //     this.signedIn = authState.state === 'signedIn';
    //     if (!authState.user) {
    //       this.user = null;
    //       this.userInfo = {};
    //     } else {
    //       this.user = authState.user;
    //       if (this.signedIn && authState && authState.user && authState.user.attributes) {
    //         this.userInfo = authState.user.attributes;
    //         this.userInfo.signedIn = this.signedIn;
    //         // this.commanSubscribeService.sendUserInfo(this.userInfo);
    //       }
    //     }
    //   });

    // if (environment.production) {
    //   window['console']['log'] = function () { };
    // }
  }

  private trackActivity(triggeredInfo: any): void {
    const duration = Number(((Date.now() - this.enterTime) / 1000).toFixed(0));
    this.pageDuration = duration;
    this.userActivityService.track(triggeredInfo, duration);
    this.enterTime = Date.now();
  }

  private schedulePendingPageView(url: string, duration: number): void {
    if (this.pendingPageView) {
      clearTimeout(this.pendingPageView.timer);
    }
    const triggeredInfo = {
      actionType: "navigation",
      clickAction: "page-view",
      metaData: { title: url, timeStamp: new Date().toISOString() },
    };
    // Fallback: fire after 2s if orgId never arrives (pages without org context)
    const timer = setTimeout(() => {
      this.userActivityService.track(triggeredInfo, duration);
      this.pendingPageView = null;
    }, 2000);
    this.pendingPageView = { triggeredInfo, duration, timer };
  }

  hidePrivateChat = false;
  ngOnInit() {
    this.userActivityService.requestBrowserGeolocation();
    this.clientDetails = environment.clientDetails;
    this.hideAIChatbot = window.parent !== window;
    console.log(environment.environment);
    if (
      this.router.url.includes("/album/audio/") ||
      this.router.url.includes("/album/channel/audio/")
    ) {
      this.hidePrivateChat = true;
    }
    let mediaPlayerDataSubscription = this.commanSubscribeService
      .getMediaPlayerData()
      .subscribe((response) => {
        if (
          (response.key == "musicList" && response.value.length > 0) ||
          (response.key == "is_show_musicPlayer" && response.value)
        ) {
          // let isAudioPlaying = response.value.filter(a=>a.isAudioPlaying);
          // if(isAudioPlaying.length > 0){
          this.hidePrivateChat = true;
          // }
        } else {
          if (
            this.router.url.includes("/album/audio/") ||
            this.router.url.includes("/album/channel/audio/")
          ) {
            this.hidePrivateChat = true;
          } else {
            this.hidePrivateChat = false;
          }
        }
      });

    let locInfo = this.commanSubscribeService.locationInfo;
    this.currentLocation =
      locInfo && Object.keys(locInfo).length > 0
        ? locInfo
        : this.storageService.getItem("current_location");
    if (
      !this.currentLocation ||
      Object.keys(this.currentLocation).length == 0
    ) {
      this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = this.currentLocation
            ? this.currentLocation
            : {};
        } else {
          this.currentLocation = json;
          this.storageService.setItem("current_location", this.currentLocation);
        }
      });
    }

    if (window.location.href.includes("token") && !window.location.pathname.includes('/preview')) {
      let val = window.location.href.split("token=");
      let token = val[1].split("&type=");
      let typeVal = token[1] ? token[1].split("&") : "";
      let access_token = { access_token: token[0] };
      this.storageService.setItem("user_Info", access_token);
      this.storageService.setItem("app_type", typeVal[0]);
    }
    // else {
    //   this.storageService.deleteItem("app_type");
    // }
    let portalChange = this.storageService.getItem("portalChange");
    if (
      !localStorage.userInfo &&
      portalChange &&
      portalChange.requestFrom == "login"
    ) {
      this.landingPageService.openConsumerSignIn();
      this.storageService.deleteItem("portalChange");
    }
    if (window.location.pathname.includes("watch/")) this.content = "video";
    else this.content = "live";

    // if (!window.location.pathname.includes('stream') || !window.location.pathname.includes('watch'))
    this.deviceInfo = this.getMobileOperatingSystem();
    if (
      window.location.pathname.includes("stream/") ||
      window.location.pathname.includes("watch/")
    ) {
      this.deviceInfo = this.getMobileOperatingSystem();
      this.hideContent = true;
    } else {
      this.hideContent = false;
    }
    this.userInfo = this.commanSubscribeService.userInfo;
    this.initFullStory();
    this.userInfoSubscription = this.commanSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        if (this.userInfo && this.userInfo.id) {
          this.globalPubnubService.init();
          this.globalPubnubService.subscribeToChannels(this.userInfo.id);
        }
        // let affiliateUser = this.storageService.getItem("isAffiliateUser");
        // if (this.userInfo && this.userInfo.access_token && affiliateUser) {
        //   this.metamaskService.initializeWallet(true);
        // }
        this.initFullStory();
      });
    this.settingsDataSubscription = this.commanSubscribeService
      .getICWebpageThemeSettings()
      .subscribe((response) => {
        document.documentElement.style.setProperty(
          "--scroll-color",
          this.getFadedColor(response?.toastr_bg_color, 0.7),
        );
        this.applyLoaderTheme(response);
      });

    this.commanSubscribeService.getOrgIdInfo().subscribe((orgId: any) => {
      if (this.pendingPageView) {
        clearTimeout(this.pendingPageView.timer);
        this.pendingPageView.triggeredInfo.organizationId = orgId || null;
        this.userActivityService.track(
          this.pendingPageView.triggeredInfo,
          this.pendingPageView.duration,
        );
        this.pendingPageView = null;
      }
    });

    this.triggeredInfoSubscription = this.commanSubscribeService
      .getTriggeredEvent()
      .subscribe((response) => {
        if (response) {
          this.trackActivity(response);
        }
      });

    // this.deviceInfoSubscription = this.commanSubscribeService.getDeviceType().subscribe(response => {
    //   this.deviceInfo = response;
    //   if (this.deviceInfo == 'ios' || this.deviceInfo == 'android')
    //     this.hideContent = true;
    //   else
    //     this.hideContent = false;
    // });

    // if(!this.otherDevice)
    // this.triggerAppOpen();

    let cordova = false;
    let interval = setInterval(() => {
      if (window.hasOwnProperty("cordova")) {
        clearInterval(interval);
        cordova = true;
        document.addEventListener("deviceready", this.onDeviceReady, false);
      }
    }, 1000);
    setTimeout(() => {
      if (interval) {
        clearInterval(interval);
      }
    }, 10000);
    // this.metamaskService.setupVisibilityListener();
  }
  private addOpacityToColor(color: string, opacity: number): string {
    // If the color is in hex format
    if (color.startsWith("#")) {
      // Convert hex to RGB
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    // If the color is already in rgb or rgba format
    else if (color.startsWith("rgb")) {
      return color.replace(")", `, ${opacity})`).replace("rgb", "rgba");
    }
    // Default fallback
    return `rgba(235, 169, 33, ${opacity})`;
  }
  deviceType: any = "browser";
  onDeviceReady = () => {
    let platform = "browser";
    if (typeof device == "object") {
      platform = device.platform ? device.platform.toLowerCase() : platform;
    }
    this.commanSubscribeService.deviceType = platform;
    this.commanSubscribeService.sendAppType(platform);
    // alert(this.commanSubscribeService.deviceType);
    this.deviceType = platform;
  };
  fallbackToStore() {
    if (!this.iphone)
      window.location.replace(
        "https://play.google.com/store/apps/details?id=com.arevea.tv",
      );
    else
      window.location.replace(
        "https://apps.apple.com/in/app/arevea/id1535047464",
      );
  }

  openApp() {
    window.location.replace(
      "intent://app/SplashScreen#Intent;scheme=dev1.arevea.com;package=com.arevea.tv;end",
    );
  }

  triggerAppOpen() {
    this.openApp();
    setTimeout(() => {
      this.fallbackToStore();
    }, 700);
  }

  getcheck() {
    var now = new Date().valueOf();
    setTimeout(() => {
      // if (new Date().valueOf() - now > 100)
      window.location.href =
        "https://apps.apple.com/in/app/arevea/id1535047464";
      // window.location.hre = "https://apps.apple.com/in/app/arevea/id1535047464";
    }, 25);
    window.location = "areveatviosapp://";
  }
  // getMobileOperatingSystem() {
  //   var userAgent = navigator.userAgent || navigator.vendor || window['opera'];
  //   if (/windows phone/i.test(userAgent)) {
  //     return false;
  //   }
  //   if (/android/i.test(userAgent)) {
  //     return 'android';
  //   }
  //   if (/iPhone|iPod/.test(userAgent) && !window['MSStream']) {
  //     this.iphone = true;
  //     this.getcheck();
  //     return false;
  //   }
  //   return true;
  // }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window["opera"];
    if (/windows phone/i.test(userAgent)) {
      return "web";
    }
    if (/android/i.test(userAgent)) {
      return "android";
    }
    if (/iPhone|iPod/.test(userAgent) && !window["MSStream"]) {
      return "ios";
    }
    return "web";
  }

  // initFullStory() {
  //     if (Object.keys(this.userInfo)?.length != 0) {
  //       FullStory.init({
  //         orgId: environment.FullStory_OrgID,
  //         devMode: environment.environment == "prod" || environment.environment == "preprod" ? false : true
  //       });
  //       FullStory.identify(this.userInfo.id, {
  //         displayName: this.userInfo.user_first_name + " " + this.userInfo.user_last_name
  //         // email: this.userInfo.email
  //        });
  //       //  FullStory.setUserVars({
  //       //   eventFrom : "Fan"
  //       //  })
  //     }
  //   }

  initFullStory() {
    console.log("FullStory Environment:", environment);
    if (!environment.FullStory_OrgID) {
      return;
    }
    console.log("FullStory Org ID:", environment.FullStory_OrgID);
    init({
      orgId: environment.FullStory_OrgID,
      devMode:
        environment.environment == "prod" ||
        environment.environment == "preprod"
          ? false
          : true,
    });
    if (Object.keys(this.userInfo)?.length != 0) {
      FullStory("setIdentity", {
        uid: this.userInfo.id,
        properties: {
          displayName:
            this.userInfo.user_first_name + " " + this.userInfo.user_last_name,
        },
        // email: this.userInfo.email
      });
      //  FullStory.setUserVars({
      //   eventFrom : "Fan"
      //  })
    }
  }

  ngOnDestroy() {
    this.storageService.deleteItem("app_type");
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
    if (this.deviceInfoSubscription) this.deviceInfoSubscription.unsubscribe();
    if (this.triggeredInfoSubscription) {
      this.triggeredInfoSubscription.unsubscribe();
    }
    this.settingsDataSubscription?.unsubscribe();
  }
}
